import React from "react";
import "./sentiment.scss";
import {ReactComponent as PositiveSentiment} from "../../../assets/sentiment/PositiveSentiment.svg";
import {ReactComponent as NegativeSentiment} from "../../../assets/sentiment/NegativeSentiment.svg";
import {ReactComponent as NeutralSentiment} from "../../../assets/sentiment/NeutralSentiment.svg";
import PropTypes from "prop-types";
import {capitalizeFirstLetter} from "../helpers/utility";

const getClassNameBySentiment = (callSentiment) => {
    return callSentiment?.toLowerCase() === CALL_SENTIMENT.POSITIVE ? 'positive' : callSentiment?.toLowerCase() === CALL_SENTIMENT.NEGATIVE ? 'negative' : 'neutral';
}
const CALL_SENTIMENT = {
    POSITIVE: 'positive',
    NEGATIVE: "negative",
    NEUTRAL: "neutral",
    UNAVAILABLE: 'unavailable'
}


const Sentiment = ({sentiment, isBoldText}) => {
    const sentimentToShow = !!sentiment ? sentiment : CALL_SENTIMENT.UNAVAILABLE
    return <div className={"sentiment-text"}>{sentiment?.toLowerCase() === CALL_SENTIMENT.POSITIVE ? <PositiveSentiment/>
        : sentiment?.toLowerCase() === CALL_SENTIMENT.NEGATIVE ? <NegativeSentiment/>
            : <NeutralSentiment/>}
        <span className={`${getClassNameBySentiment(sentiment)} ${isBoldText ? "bold-text" : ""}`}>{capitalizeFirstLetter(sentimentToShow)}</span>
    </div>
}

Sentiment.prototype = {
    sentiment: PropTypes.string,
    isBoldText: PropTypes.bool
}
export default Sentiment;